import React, { useState } from 'react';

import { useDisclosure } from '@mantine/hooks';
import type { PackageUtilizationExpectationListItem } from 'types';

import ModalContext, { ModalType } from './ModalContext';
import ManagePackagesModal from '../ManagePackagesModal';

const ModalProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [opened, { open, close }] = useDisclosure(false);
  const [modalType, setModalType] = useState<ModalType | null>(null);
  const [modalData, setModalData] = useState<PackageUtilizationExpectationListItem | null>(null);

  const openModal = (type: ModalType, data?: PackageUtilizationExpectationListItem | null): void => {
    setModalType(type);
    setModalData(data || null);
    open();
  };

  const closeModal = (): void => {
    setModalType(null);
    setModalData(null);
    close();
  };

  return (
    <ModalContext.Provider
      value={{
        modal: { opened, type: modalType, packageExpectation: modalData },
        openModal,
        closeModal,
      }}
    >
      {children}
      <ManagePackagesModal />
    </ModalContext.Provider>
  );
};

export default ModalProvider;
